var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"homeRef",staticClass:"home"},[_c('banner'),_c('copyRight'),_c('dubbing'),_c('serviceCase'),_c('leaderBoard'),_c('programme'),_c('dubber'),_c('customerVoice'),_c('rightAside',{attrs:{"asideItemShowFlag":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }